// extracted by mini-css-extract-plugin
export default {"BlockResponsive":"BlockResponsive_BlockResponsive__Df3ZJ"};